/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export { UpdateEvent };
const eventInit = {
    bubbles: true,
    cancelable: true,
    composed: true,
};
class UpdateEvent extends Event {
    mainGraphId;
    graphId;
    nodeId;
    affectedGraphs;
    static eventName = "update";
    constructor(mainGraphId, graphId, nodeId, affectedGraphs) {
        super(UpdateEvent.eventName, { ...eventInit });
        this.mainGraphId = mainGraphId;
        this.graphId = graphId;
        this.nodeId = nodeId;
        this.affectedGraphs = affectedGraphs;
    }
}
//# sourceMappingURL=event.js.map